import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Notification from '~/components/Notification';
import {nbsp} from '~/constants/StringConstants';
import {ID_VIEW_MAP} from '~/constants/ProductConstants';
import {listify} from '~/utils/text';
import {getViewName} from '~/utils/catalog';

const propTypes = {
  confirm: PropTypes.func,
  dismiss: PropTypes.func,
  notification: PropTypes.shape({
    payload: PropTypes.shape({
      matchedAreas: PropTypes.array,
      mismatchedAreas: PropTypes.array,
      mismatchedNoPhotography: PropTypes.array,
      nextProduct: PropTypes.object,
      previousColorId: PropTypes.string,
      previousStyleId: PropTypes.string,
      productColors: PropTypes.array,
      productName: PropTypes.string
    })
  }),
  swapProduct: PropTypes.func
};

/** @extends {Component<PropTypes.InferProps<typeof propTypes>>} */
export class SwapProductMismatchedAreas extends Component {
  static displayName = 'SwapProductMismatchedAreas';
  static propTypes = propTypes;

  state = {
    colorName: '',
    productName: '',
    namedMatchedAreas: [],
    namedMismatchedAreas: []
  };

  componentDidMount() {
    const {matchedAreas, mismatchedAreas, productColors, nextProduct} =
      this.props.notification.payload;
    const namedMatchedAreas = matchedAreas.map(viewIndex => {
      return getViewName(ID_VIEW_MAP[viewIndex], false).toLowerCase();
    });
    const namedMismatchedAreas = mismatchedAreas.map(viewIndex => {
      return getViewName(ID_VIEW_MAP[viewIndex], false).toLowerCase();
    });
    const color = productColors.filter(color => {
      return color.id === nextProduct.colorId;
    })[0] || {name: 'this color'};
    this.setState({
      namedMatchedAreas,
      namedMismatchedAreas,
      colorName: color.name
    });
  }

  swapAnyway = () => {
    const {nextProduct, previousColorId, previousStyleId} =
      this.props.notification.payload;
    this.props.swapProduct({
      previousColorId,
      previousStyleId,
      nextProduct,
      isAD: false,
      clearMismatchedViews: true
    });
    this.props.confirm();
  };

  renderMessage = () => {
    if (this.props.notification.payload.matchedAreas.length === 0) {
      return `we will need to remove your ${listify(
        this.state.namedMismatchedAreas
      )} design(s).`;
    }
    return `we will only retain the ${listify(
      this.state.namedMatchedAreas
    )} design(s).`;
  };

  renderMissingPhotography() {
    const {mismatchedNoPhotography, productName} =
      this.props.notification.payload;
    return (
      <Notification
        dismiss={this.props.dismiss}
        title={"We can't do this online...yet"}
        type="ERROR">
        <br />
        <p className="ndx-cta1">
          Our Design Lab is unable to place your
          {nbsp}
          {listify(mismatchedNoPhotography)} design(s) on the
          {nbsp}
          {productName}. Reach out to one of our Customer Service
          Representatives to use your
          {nbsp}
          {listify(mismatchedNoPhotography)} design on this product.
        </p>
        <Button
          size="large"
          variant="Primary"
          className="notification-cta"
          href="#/help"
          onClick={this.props.dismiss}>
          CONTACT US
        </Button>
        <p className="ndx-cta1">
          <br />
          or
          {nbsp}
          <Link button className="ndx-cta-Link" onClick={this.swapAnyway}>
            {' '}
            Remove Sleeve Design.
          </Link>
        </p>
      </Notification>
    );
  }

  renderMissingDesignAreas() {
    return (
      <Notification
        dismiss={this.props.dismiss}
        title={
          <span>
            Whoops! This product does not support <br /> one or more of your
            design areas.
          </span>
        }
        type="ERROR">
        <br />
        <p className="ndx-cta1">
          If you switch to the
          {nbsp}
          {this.props.notification.payload.productName} in
          {nbsp}
          {this.state.colorName}, {this.renderMessage()}
        </p>
        <a
          className="ndx-cta-Primary ndx-NotificationCta--long"
          onClick={this.swapAnyway}>
          CONTINUE
        </a>
        <p className="ndx-cta1">
          or
          {nbsp}
          <a href="#/productCatalog" onClick={this.props.dismiss}>
            choose another product.
          </a>
        </p>
      </Notification>
    );
  }

  render() {
    return this.props.notification.payload.mismatchedNoPhotography.length
      ? this.renderMissingPhotography()
      : this.renderMissingDesignAreas();
  }
}

import {bindActionCreators} from 'redux';
import {swapProduct} from '~/actions/ProductActions';
import {confirm} from '~/actions/NotificationActions';

function actions(dispatch) {
  return bindActionCreators(
    {
      swapProduct,
      confirm
    },
    dispatch
  );
}

import {connect} from 'react-redux';
import {Button, Link} from '@customink/pigment-react';

export default connect(null, actions)(SwapProductMismatchedAreas);
